export default __webpack_public_path__ + "static/media/DNo.7-1.0c9570a0.jpg";